<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>
      {{
        isAtp
          ? "Declined to Sign the ATP."
          : isFixedPrice
          ? "Declined the Offer."
          : "Declined the Invitation."
      }}
    </h2>
    <ng-container>
      <div class="">
        <div class="mb-10">
          {{
            isAtp
              ? "You have declined to sign the ATP."
              : isFixedPrice
              ? "You have declined the offer."
              : "You have declined the invitation."
          }}
        </div>
        <br />
        <br />
        <div class="panelfields mt-30">
          <button
            type="submit"
            class="btn btn-primary w-10"
            (click)="closeDialog()"
          >
            Close
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
